import WaitingForDelivery from './WaitingForDelivery'

export default WaitingForDelivery